export const actionTypes = {
    UPDATE_FLEET_OVERVIEW_INITIAL_LOAD: 'fleetOverview/UPDATE_FLEET_OVERVIEW_INITIAL_LOAD',

    // Base types (used by getApiActionCreator to emit LOADING / SUCCESS / ERROR)
    GET_BAR_CHARTS: 'fleetOverview/GET_BAR_CHARTS',
    GET_STATISTICS_ASSETS: 'fleetOverview/GET_STATISTICS_ASSETS',
    GET_STATISTICS_ASSETSGROUP: 'fleetOverview/GET_STATISTICS_ASSETSGROUP',
    GET_STATISTICS_POWERTRAIN: 'fleetOverview/GET_STATISTICS_POWERTRAIN',
    GET_ANALYTICS_AGGREGATED_POWERTRAIN: 'fleetOverview/GET_ANALYTICS_AGGREGATED_POWERTRAIN',
    GET_ANALYTICS_AGGREGATED_ASSET: 'fleetOverview/GET_ANALYTICS_AGGREGATED_ASSET',
    GET_ANALYTICS_AGGREGATED_ASSETGROUP: 'fleetOverview/GET_ANALYTICS_AGGREGATED_ASSETGROUP',

    // Request types (watched by FleetOverviewSaga)
    GET_BAR_CHARTS_REQUEST: 'fleetOverview/GET_BAR_CHARTS_REQUEST',
    GET_STATISTICS_ASSETS_REQUEST: 'fleetOverview/GET_STATISTICS_ASSETS_REQUEST',
    GET_STATISTICS_ASSETSGROUP_REQUEST: 'fleetOverview/GET_STATISTICS_ASSETSGROUP_REQUEST',
    GET_STATISTICS_POWERTRAIN_REQUEST: 'fleetOverview/GET_STATISTICS_POWERTRAIN_REQUEST',
    GET_ANALYTICS_AGGREGATED_POWERTRAIN_REQUEST: 'fleetOverview/GET_ANALYTICS_AGGREGATED_POWERTRAIN_REQUEST',
    GET_ANALYTICS_AGGREGATED_ASSET_REQUEST: 'fleetOverview/GET_ANALYTICS_AGGREGATED_ASSET_REQUEST',
    GET_ANALYTICS_AGGREGATED_ASSETGROUP_REQUEST: 'fleetOverview/GET_ANALYTICS_AGGREGATED_ASSETGROUP_REQUEST',

    SET_EXPANDED_ASSET_GROUP: 'fleetOverview/SET_EXPANDED_ASSET_GROUP',
    SET_EXPANDED_POWERTRAIN: 'fleetOverview/SET_EXPANDED_POWERTRAIN',
    SET_FLEET_USER_TYPE: 'fleetOverview/SET_FLEET_USER_TYPE',
    UPDATE_REFRESH_CACHE_FLAG: 'fleetOverview/UPDATE_REFRESH_CACHE_FLAG',

    // (Keeping original key to avoid breaking existing reducers; consider correcting typo later)
    CLEAR_FLEET_OVERVIEW_DATA: 'fleetOverview/CLEAR_FLEET_OVERVIEW_DATA',
};

export const pageSize = 1000; // Default page size for fleet statistics API call
export const listItemHeight = 42; // Height of each item in the list
export const itemsPerPage = 100; // Number of items to load per page in pagination

export const toggleButtonOptions = {
    POWERTRAINS: 'Powertrains',
    ASSETGROUPS: 'AssetGroups',
    ASSETS: 'Assets'
};

export const STATISTICS_API_TYPES = {
    ASSET: 'Asset',
    ASSETGROUP: 'AssetGroup',
    POWERTRAIN: 'Powertrain'
};

export const ANOMALY_TYPES = {
    DRIVE_COOLING_ANOMALY: 'ABB.Powertrain.Frontend.DriveAnomaly',
    MOTOR_ANOMALY: 'ABB.Powertrain.Frontend.MotorAnomaly'
};

export const getToggleButtonOptions = (translate) => [
    { label: translate('ABB.Powertrain.Frontend.powertrainsLabel'), value: toggleButtonOptions.POWERTRAINS },
    { label: translate('ABB.Powertrain.Frontend.assetGroupsLabel'), value: toggleButtonOptions.ASSETGROUPS },
    { label: translate('ABB.Powertrain.Frontend.assetsLabel'), value: toggleButtonOptions.ASSETS }
];
